import { http } from "@/plugins/http";
import * as TYPES from "./mutation-types";

export const loadComplectations = ({ dispatch },  params) => {
  return http
    .get(`/cars/stock/complectations/?${params}`)
    .then((data) => {
      dispatch("setComplectations", data.data);
    })
    .catch((e) => {
      return Promise.reject(e);
    });
};

export const setComplectations = ({ commit }, value) => commit(TYPES.SET_COMPLECTATIONS, value);
